import { Box, Checkbox, Flex, Grid, Image, Text, useToast } from '@chakra-ui/react'
import { FaFilePdf } from 'react-icons/fa'
import { memo, useState } from 'react'
import { UploadButton } from './UploadButton'
import { useGerarPedido } from '../../../contexts/GerarPedidoProvider'
import { useQueryClient } from 'react-query'

const ProductComponent = ({ product, handleSelectItem, dadosPedido, dadosFaturamento, consultor, caricatura }) => {
  // const { solicitarCaricatura, isLoadingSolicitarCaricatura } = useGerarPedido()

  // const queryClient = useQueryClient()

  const [visualized, setVisualized] = useState(false)
  const [checked, setChecked] = useState(false)
  const toast = useToast({
    position: 'top-right',
  })

  function handleApproveItem() {
    if (!visualized) {
      return toast({
        title: 'Atenção',
        description: 'Você precisa visualizar o layout antes de aprovar.',
        status: 'warning',
        duration: 9000,
        isClosable: true,
      })
    }
    handleSelectItem(product)
    setChecked(!checked)
  }

  // async function handleSolitarCaricatura() {
  //   if (isLoadingSolicitarCaricatura) return

  //   const params = {
  //     nome_produto: product.nome_produto,
  //     quantidade_produto: product.quantidade,
  //     prazo_producao: product.prazo,
  //     vendedor: consultor.nome,
  //     numero_nota: dadosPedido.numero_nota,
  //     codigo_vendedor: consultor.codigo_vendedor,
  //     codigo_produto: product.codigo_produto,
  //     sequencia: product.sequencia,
  //     nome_cliente: dadosFaturamento.nome_parceiro,
  //     codigo_parceiro: dadosFaturamento.codigo_parceiro,
  //     numero_pedido: dadosPedido.numero_pedido,
  //   }

  //   const res = await solicitarCaricatura(params)

  //   if (res) {
  //     queryClient.setQueryData(['infoPedido', { numeroNota: dadosPedido.numero_pedido }], (oldData) => {
  //       return {
  //         ...oldData,
  //         itens: oldData.itens.map((item) => {
  //           if (item.sequencia === product.sequencia) {
  //             return {
  //               ...item,
  //               caricatura_ativa: true,
  //             }
  //           }
  //           return item
  //         }),
  //       }
  //     })
  //   }
  // }

  return (
    <Grid
      gridTemplateColumns="repeat(12, 1fr)"
      color="#1D1D1D"
      fontSize="12px"
      fontWeight="bold"
      border="1px solid #cfcfcf"
      p={3}
      placeItems="center"
    >
      <Box gridColumn="span 4" justifySelf="start">
        <Flex gap={4}>
          <Image
            fallbackSrc="https://via.placeholder.com/120"
            src={product?.imagens_produto[0].url}
            alt="Imagem do produto"
            boxSize="120px"
            objectFit="cover"
          />

          <Flex flexDir="column" fontWeight="normal" gap={1}>
            <Text>
              Cod {product.codigo_produto}{' '}
              <Text as="a" textDecor="underline" color="blue.500" cursor="pointer" href={product.link_produto} target="_blank" rel="noreferrer">
                + Mais informações
              </Text>
            </Text>
            <Text>Cor: {product.descricao_cor}</Text>
            <Text>Gravação: {product.nome_personalizacao}</Text>
            <Text>Impressões: {product.qtd_batida}</Text>
            <Text>Prazo de produção: {product.prazo} dias úteis</Text>
          </Flex>
        </Flex>
      </Box>
      <Box gridColumn="span 1" textAlign="center">
        {product.quantidade}
      </Box>
      <Box gridColumn="span 2" textAlign="center">
        {product.formattedPrecoVenda}
      </Box>
      <Box gridColumn="span 2" textAlign="center">
        {product.formattedValorTotalItem}
      </Box>
      <Box gridColumn="span 3" textAlign="center">
        <Flex alignItems="end" gap={4}>
          {/* TODO: descomentar quando terminar o fluxo de caricatura */}

          {/* {caricatura && product.item_caricatura && (
            <Flex flexDir="column" gap={1} alignItems="center" pointerEvents={'auto'}>
              <Text color="#378BBF" as="label" htmlFor={product.sequencia}>
                Solicitar Caricatura
              </Text>
              <Checkbox
                colorScheme="green"
                size="lg"
                borderColor="#cfcfcf"
                sx={{
                  '.chakra-checkbox__control': {
                    borderRadius: 'full',
                    width: '30px',
                    height: '30px',
                  },
                }}
                isChecked={product.caricatura_ativa}
                disabled={isLoadingSolicitarCaricatura}
                onChange={() => handleSolitarCaricatura()}
              />
            </Flex>
          )} */}
          <UploadButton id={product.sequencia} name={product.sequencia} item={product} dadosPedido={dadosPedido} />

          <Flex
            flexDir="column"
            gap={1}
            alignItems="center"
            pointerEvents={'auto'}
            as="a"
            href={product.link_layout}
            onClick={() => setVisualized(true)}
            target="_blank"
            rel="noreferrer"
          >
            <Text color="#378BBF" as="label" htmlFor="aprovar">
              Visualizar
            </Text>

            <FaFilePdf size="32px" color="#378BBF" />
          </Flex>
          <Flex flexDir="column" gap={1} alignItems="center">
            <Text color="#378BBF" as="label" htmlFor={product.sequencia}>
              Aprovar
            </Text>
            <Checkbox
              colorScheme="green"
              size="lg"
              id={product.sequencia}
              borderColor="#cfcfcf"
              sx={{
                '.chakra-checkbox__control': {
                  borderRadius: 'full',
                  width: '30px',
                  height: '30px',
                },
              }}
              // isChecked={isSelected}
              isChecked={checked}
              onChange={() => handleApproveItem(product)}
            />
          </Flex>
        </Flex>
      </Box>
    </Grid>
  )
}

export const Product = memo(ProductComponent, (prevProps, nextProps) => {
  return prevProps.isSelected === nextProps.isSelected
})
